import Row from 'antd/lib/row';
import ApartmentOutlined from '@ant-design/icons/lib/icons/ApartmentOutlined';
import { SECONDARY_COLOR } from 'src/theme';
import { BillReadOnlyField } from './BillReadOnlyField';
import { BillSectionHeader } from './BillSectionHeader';
import { BillFormField, IBillSectionProps } from './BillFormField';

export const BillVendorSection = (props: IBillSectionProps) => (
    <div className="customer-bill-section-source" style={{ marginBottom: 14 }}>
        <BillSectionHeader
            icon={<ApartmentOutlined style={{ color: SECONDARY_COLOR }} />}
            title="Vendor"
            fields={['zone', 'utility', 'market']}
            editableFields={props.editableFields}
        />
        <Row gutter={[20, 10]}>
            {/* Vendor name isn't updatable — always read-only. */}
            <BillReadOnlyField label="VENDOR NAME" value={props.form.vendor} />
            <BillFormField {...props} label="ZONE" field="zone" />
            <BillFormField {...props} label="UTILITY" field="utility" />
            <BillFormField {...props} label="MARKET" field="market" />
        </Row>
    </div>
);
